module.exports = __webpack_public_path__ + "images/d1f5d0c100e714d3efde82a397b3ab04-no-icon1.png";